import { useTranslation } from 'next-i18next';
import React from 'react';

import { FieldApp } from '@/modules/Onboarding/components/ConnectEcoSystem/FieldApp';
import { Typography } from '@/shared/components/atoms';
import CelebrationModal from '@/shared/components/molecules/CelebrationModal';

const OperationCelebration = () => {
  const { t } = useTranslation();

  return (
    <CelebrationModal className='max-w-[700px]'>
      <Typography
        weight='medium'
        variant='h2'
        className='mb-24 flex flex-col items-center border-b-xs border-neutralVariant-90 pb-24'
      >
        <span>{`${t('first-operation-success')} 🎉`}</span>
        <span>{t('field-app-start')}</span>
      </Typography>
      <FieldApp flex='flex-row-reverse' />
    </CelebrationModal>
  );
};

export default OperationCelebration;
